enum IpcKeyName {
    RDP = 'RDP',
    CDF = 'CDF',
    PSV = 'PSV',
    RGOS = 'RGOS',
    RGOSh = 'RGOSh',
}

export default IpcKeyName;